// src\pages\marketing\admin\ProjectsAdmin.js
import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { getAuth } from "firebase/auth";

export default function ProjectsAdmin() {
  const [items, setItems] = useState([]);
  const [title, setTitle] = useState("");
  const [slug, setSlug] = useState("");
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(true);

  const navigate = useNavigate();

  async function load() {
    setErr("");
    setLoading(true);

    try {
      const auth = getAuth();
      const user = auth.currentUser;
      if (!user) throw new Error("Not logged in");

      const token = await user.getIdToken();

      const res = await fetch("https://modularobjects.com/marketing/api/admin/projects", {
        headers: { Authorization: `Bearer ${token}` },
        credentials: "include",
      });

      const data = await res.json();
      if (!res.ok) throw new Error(data?.error || "Failed to load");

      setItems(Array.isArray(data) ? data : []);
    } catch (e) {
      console.error("❌ load admin projects:", e);
      setItems([]);
      setErr(e?.message || "Failed to load");
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    load();
  }, []);

  async function create() {
    try {
      const auth = getAuth();
      const user = auth.currentUser;
      if (!user) throw new Error("Not logged in");

      const token = await user.getIdToken();

      const res = await fetch("https://modularobjects.com/marketing/api/admin/projects", {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        credentials: "include",
        body: JSON.stringify({ slug, title, is_published: 0 }),
      });

      const data = await res.json();
      if (!res.ok) throw new Error(data?.error || "Create failed");

      await load();
      navigate(`/marketing/admin/projects/${data.id}`); // ✅ SPA navigacija
    } catch (e) {
      console.error("❌ create project:", e);
      setErr(e?.message || "Create failed");
    }
  }

  return (
    <div className="p-4 space-y-6">
      <h1 className="text-2xl font-bold">Marketing Projects — Admin</h1>

      {err && (
        <div className="p-3 rounded border border-red-300 bg-red-50 text-red-700">
          {err}
        </div>
      )}

      <div className="p-4 rounded border bg-white/60 dark:bg-black/20 space-y-2">
        <div className="font-semibold">Create new project</div>
        <input
          className="w-full border rounded px-3 py-2"
          value={title}
          onChange={(e) => setTitle(e.target.value)}
          placeholder="Title"
        />
        <input
          className="w-full border rounded px-3 py-2"
          value={slug}
          onChange={(e) => setSlug(e.target.value)}
          placeholder="Slug (kitchen-belgrade-58)"
        />
        <button className="btn-primary" onClick={create} disabled={!title || !slug}>
          Create
        </button>
      </div>

      {loading ? (
        <div className="opacity-70">Loading…</div>
      ) : (
        <div className="grid gap-3">
          {items.map((p) => (
            <Link
              key={p.id}
              to={`/marketing/admin/projects/${p.id}`}
              className="p-3 rounded border hover:opacity-90"
            >
              <div className="font-semibold">{p.title}</div>
              <div className="text-xs opacity-70">
                {p.slug} • {p.is_published ? "PUBLISHED" : "DRAFT"}
              </div>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
